import creditCards from 'angular-credit-cards';
import assign from 'lodash/assign';
import 'angular-payments';

import { InputContainer } from 'components/inputContainer/inputContainer';
import { CreditCardImage } from 'components/creditCardImage/creditCardImage';
import { FormatCardExpiration } from 'directives/formatCardExpiration';
import { CvcInfo } from './cvcInfo/cvcInfo';

import template from './creditCardForm.html';
import './creditCardForm.scss';

export const CreditCardForm = angular
    .module('checkout.components.creditCardForm', [
        creditCards,
        'angularPayments',
        InputContainer,
        CreditCardImage,
        CvcInfo,
        FormatCardExpiration
    ]).component('creditCardForm', {
        template,
        bindings: {
            model: '=',
            disableCardNumberField: '<',
            hideCvcInput: '<',
            hideCreditCardImage: '<',
            onCreditCardTypeUpdated: '<'
        },
        controller: class CreditCardFormCtrl {
            constructor($timeout) {
                assign(this, {
                    $timeout
                });
            }

            $onInit() {
                // Workaround for a bug with angular-payments https://github.com/laurihy/angular-payments/issues/93
                if (this.model) {
                    this.model.expiration = this.model.expiration || null;
                } else {
                    this.model = {
                        expiration: null
                    };
                }
            }

            updateCreditCardType() {
                this.$timeout(() => {
                    this.onCreditCardTypeUpdated(this.creditCardForm.cardNumber.$ccType);
                });
            }
        }
    }).name;



// WEBPACK FOOTER //
// ./src/app/components/creditCardForm/creditCardForm.js